export const services = [
  {
    slug: 'real-estate-media',
    number: '01',
    icon: 'Home',
    title: 'Real Estate Media',
    short: 'Real estate sales videos and services that create attention and inspire action.',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Aerial Drone / UAV services, Photography and Video',
      '360-degree Photography, Video, and Virtual Walkthroughs',
      'Wide Angle, Interior, and Exterior HDR Photography',
      'Video Production for Online and DVD Distribution',
      'Experienced Social Media Marketing and Consulting',
      'Graphic Design for Print and Online Presence',
      'Marketing Highlight Videos Reels'
    ]
  },
  {
    slug: 'audio-recording',
    number: '02',
    icon: 'Mic',
    title: 'Audio Recording',
    short: 'Professional audio recording studio services, from vocals to finished masters.',
    image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Vocal Coaching and Recording',
      'Original Music Arrangement, Creation of all Popular Styles',
      'Mixing and Mastering Services',
      'Music Distribution via Online Outlets',
      'Jingles and Music soundtracks',
      'Radio commercials from Concept to Air',
      'Professional Voice work Services'
    ]
  },
  {
    slug: 'video-production',
    number: '03',
    icon: 'Video',
    title: 'Video Production',
    short: 'Professional video recording services, from first frame to final master.',
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Music Video Editing and Production',
      'Chroma Key studio and Lighting',
      'Onsite / Remote Video Multi-cam Recordings',
      'Professional Development for Broadcast',
      'Aerial Drone / UAV Video Production',
      '360 degree, Video, and Photography, Editing and Production',
      'Mastering for DVD Duplication, Online Marketing, and Broadcast'
    ]
  },
  {
    slug: 'digital-presence',
    number: '04',
    icon: 'Globe',
    title: 'Digital Presence',
    short: 'Website and social media presence consulting and development services.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Website Design and Development',
      'E-commerce Amazon Websites Development and Marketing',
      'Word Press Blog Site Development',
      'Setup for Live Online Streaming and Marketing',
      'Facebook Marketing Pages and Global Boosting',
      'Virtual Worlds Presence via 3D Design and Development',
      'Consultation of Popular Social media platforms'
    ]
  },
  {
    slug: 'av-integration',
    number: '05',
    icon: 'Monitor',
    title: 'A/V Integration',
    short: 'Audio / visual services built around your venue, your team, and your goals.',
    image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Onsite evaluation and Consultation of pre-existing Audio and Video Installations',
      'Installation of State of the Art A/V solutions and Training',
      'Media Department Establishment and Training of Personnel'
    ]
  },
  {
    slug: 'graphic-design',
    number: '06',
    icon: 'PenTool',
    title: 'Graphic Design',
    short: 'Conceptualization and creation of all your marketing materials.',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Conceptualization and Creation of all Marketing Materials',
      'Design for Print; Banner, Flyers, Logos, Business Cards, Brochures',
      'Book Design, Development and Online Distribution'
    ]
  },
  {
    slug: 'live-event-production',
    number: '07',
    icon: 'Radio',
    title: 'Live Event Production',
    short: 'Live audio and video event installation, crew management, and training.',
    image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=1600&q=85',
    services: [
      'Audio Live Event Installation, Mixing, and Takedown',
      'Live Video Event Installation, Crew Management, and Training',
      'Establish Workflow for Live or Immediate Online Content Distribution'
    ]
  },
  {
    slug: 'media-duplication',
    number: '08',
    icon: 'Disc',
    title: 'Media Duplication',
    short: 'Duplication services with custom designs, packaging, and quality care.',
    image: 'https://images.unsplash.com/photo-1619983081563-430f63602796?auto=format&fit=crop&w=1600&q=85',
    services: [
      'CD / DVD Media Duplication',
      'Custom Graphic Designs',
      'Printed Surface and Jackets',
      'Retail Packaging',
      'Small to Medium sized Production Runs'
    ]
  }
];